import _Link from '@mui/material/Link';
import { styled } from '@mui/material/styles';

export const Link = styled(_Link)`
  color: black;
  font-family: 'ProximaNovaLight';
  font-size: 14px;
  text-decoration: none;
`;